export const EMPLOYEE_FEEDBACK_USER = 'AccediaEmployeeFeedbackApp';
export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';